import {Component, Inject, OnInit} from '@angular/core';
import {Route} from '../model/route.model';
import {SettingsDataService} from '../settings-data.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Stop} from '../model/stop.model';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar} from '@angular/material';
import {HttpClient} from '@angular/common/http';
import {Point} from '../model/point.model';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {
  settingsDataService: SettingsDataService;
  selected: string;
  provider: string;
  zoom: string;

  constructor(private router: Router, private http: HttpClient,
              settingsDataService: SettingsDataService,
              private route: ActivatedRoute, private snackBar: MatSnackBar, public dialog: MatDialog) {
    this.settingsDataService = settingsDataService;
    route.params.subscribe(params => {
      if (params !== null && params['experimental'] !== null && params['experimental'] !== undefined) {
        this.settingsDataService.toggleExperimental();


        this.snackBar.open(
          this.settingsDataService.experimental ? 'Enabling experimental mode' : 'Disabling experimental mode',
          'Dismiss', {duration: 5000});
        this.router.navigate(['/']);
      }
    });
    this.provider = 'NJT_BUS';
  }

  ngOnInit() {
  }

  addRoute() {
    if (this.provider === null || this.provider === undefined) {
      this.provider = 'NJT_BUS';
    }

    this.settingsDataService.addRoute(this.selected, this.provider);
    return false;
  }

  remove(route: Route) {
    this.settingsDataService.removeRoute(route);
  }

  removeStop(stop: Stop) {
    this.settingsDataService.updatePinnedStop(stop, false);
  }

  openDialog() {
    const dialogRef = this.dialog.open(SettingsFeedbackComponent, {width: '500px'});
    dialogRef.afterClosed().subscribe(result => {
        if (result !== null && result !== undefined) {
          this.http.get(`https://ShowMeMyCommute.com:5928/feedback?id=${this.settingsDataService.identifier}&feedback=${result}`)
            .pipe()
            .subscribe(routeShape => {
              console.log('sent feedback');
            });
        }
      }
    );
  }

  increaseIconSize(increase: boolean) {
    this.settingsDataService.changeIconSize(this.settingsDataService.iconSize + (increase ? 0.2 : -0.2));
  }

  moveToStop(stop: Stop) {
    const point = new Point();
    point.lat = stop.lat;
    point.lon = stop.lon;

    this.settingsDataService.moveMapToPoint.emit(point);
  }

  onChangeProvider(event: Event) {
    const routes = this.settingsDataService.getValidRoutes(this.provider);
    if (routes !== null && routes !== undefined && routes.length > 0) {
      this.selected = routes[0];
    }
  }

  updateZoom(event: Event) {
    let zoomLevel: number;
    switch (this.zoom) {
      case 'All':
        zoomLevel = 0;
        break;
      case 'Medium':
        zoomLevel = 9;
        break;
      case 'Low':
        zoomLevel = 15;
        break;
      case 'No':
        zoomLevel = 100;
        break;
      default:
        zoomLevel = 0;
        this.zoom = 'All';
    }
    this.settingsDataService.minZoomLevel(zoomLevel);
  }
}

@Component({
  selector: 'app-settings-feedback.component',
  template: `
    <div mat-dialog-content>
      <p>Enter feedback (or Starbucks Gift Card codes):</p>
      <mat-form-field style="width:100%;">
        <textarea matInput [(ngModel)]="data" style="width:100%;"
                  cdkTextareaAutosize
                  #autosize="cdkTextareaAutosize"> cdkFocusInitial</textarea>
      </mat-form-field>
    </div>
    <div mat-dialog-actions>
      <button mat-button (click)="onNoClick()">cancel</button>
      <button mat-button color="primary" [mat-dialog-close]="data">Ok</button>
    </div>

  `
})
export class SettingsFeedbackComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<SettingsFeedbackComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string) {
  }

  ngOnInit() {
  }

  onNoClick() {
    this.dialogRef.close();
  }
}
